__turbopack_context__.v({
  "arrow": "itinerary-module__ev2RIW__arrow",
  "brandBadge": "itinerary-module__ev2RIW__brandBadge",
  "brandCurrent": "itinerary-module__ev2RIW__brandCurrent",
  "brandDivider": "itinerary-module__ev2RIW__brandDivider",
  "brandIcon": "itinerary-module__ev2RIW__brandIcon",
  "brandKicker": "itinerary-module__ev2RIW__brandKicker",
  "brandSep": "itinerary-module__ev2RIW__brandSep",
  "brandText": "itinerary-module__ev2RIW__brandText",
  "brandTotal": "itinerary-module__ev2RIW__brandTotal",
  "card": "itinerary-module__ev2RIW__card",
  "cardActive": "itinerary-module__ev2RIW__cardActive",
  "cardBody": "itinerary-module__ev2RIW__cardBody",
  "cardImage": "itinerary-module__ev2RIW__cardImage",
  "cardNoImage": "itinerary-module__ev2RIW__cardNoImage",
  "day": "itinerary-module__ev2RIW__day",
  "dayDescription": "itinerary-module__ev2RIW__dayDescription",
  "dayKicker": "itinerary-module__ev2RIW__dayKicker",
  "dayMarker": "itinerary-module__ev2RIW__dayMarker",
  "dayMarkerActive": "itinerary-module__ev2RIW__dayMarkerActive",
  "dayMarkerNum": "itinerary-module__ev2RIW__dayMarkerNum",
  "dayTitle": "itinerary-module__ev2RIW__dayTitle",
  "dayVisible": "itinerary-module__ev2RIW__dayVisible",
  "markerPulse": "itinerary-module__ev2RIW__markerPulse",
  "pill": "itinerary-module__ev2RIW__pill",
  "pillActive": "itinerary-module__ev2RIW__pillActive",
  "pillIcon": "itinerary-module__ev2RIW__pillIcon",
  "pillIconCurrent": "itinerary-module__ev2RIW__pillIconCurrent",
  "pillIconPast": "itinerary-module__ev2RIW__pillIconPast",
  "pillLabel": "itinerary-module__ev2RIW__pillLabel",
  "placeholder": "itinerary-module__ev2RIW__placeholder",
  "progress": "itinerary-module__ev2RIW__progress",
  "progressFill": "itinerary-module__ev2RIW__progressFill",
  "strip": "itinerary-module__ev2RIW__strip",
  "stripScroller": "itinerary-module__ev2RIW__stripScroller",
  "stripStuck": "itinerary-module__ev2RIW__stripStuck",
  "timeline": "itinerary-module__ev2RIW__timeline",
});
